import { SyntheticEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useAnalytics } from '~/src/features/full-buy/analytics/context';
import { TNextButtonHook } from '~/src/features/full-buy/containers/GoToNextStepButton/types';
import { goToNextStep } from '~/src/features/full-buy/store/actions/goToNextStep';
import { isHaveSelectedProducts } from '~/src/features/full-buy/store/selectors/products/isHaveSelectedProducts';

const useEquipmentsNextButton = (): TNextButtonHook => {
    const analytics = useAnalytics();
    const dispatch = useDispatch();

    const hasProducts = useSelector(isHaveSelectedProducts);

    return {
        disabled: false,
        onClick: (e: SyntheticEvent) => {
            e.stopPropagation();
            if (hasProducts) {
                analytics.equipment.chooseEquipmentContinue();
            } else {
                analytics.equipment.clickContinue();
            }
            dispatch(goToNextStep());
        },
        children: hasProducts ? 'Продолжить' : 'Мне не нужен роутер',
    };
};

export default useEquipmentsNextButton;
